import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useFieldArray } from 'react-hook-form';

import SelectInput from 'components/FormInputs/SelectInput';
import TextInput from 'components/FormInputs/TextInput';

import { States } from '../../../pages/Main/PackageListing/components/RegistrationForm/utils/formConstants';

interface AddressFieldArrayProps {
  name: string;
  numRequired?: number;
}

function AddressFieldArray({ name, numRequired = 1 }: AddressFieldArrayProps) {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const fieldArray = useFieldArray({ name: name });

  return (
    <Stack gap={4}>
      {fieldArray.fields.map((_field, index) => (
        <Grid key={index} container rowSpacing={2} columnSpacing={isMd ? 4 : 2}>
          <Grid size={12}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 'bold',
                textDecoration: 'underline',
              }}
            >
              Address {index > 0 ? index + 1 : undefined}
            </Typography>
          </Grid>

          <Grid size={12}>
            <TextInput name={`${name}.${index}.street_address`} label="Street Address" />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <TextInput name={`${name}.${index}.city`} label="City" />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <SelectInput
              name={`${name}.${index}.state`}
              label="State"
              options={States}
              sx={{
                minWidth: '100px',
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <TextInput name={`${name}.${index}.zip`} label="Zip Code" />
          </Grid>

          {fieldArray.fields.length > numRequired && (
            <Grid size={12}>
              <Button
                variant="contained"
                size="small"
                color="error"
                fullWidth
                onClick={() => {
                  console.log(`Deleting index: ${index}`);
                  fieldArray.remove(index);
                }}
              >
                Remove Address {index + 1}
              </Button>
            </Grid>
          )}
        </Grid>
      ))}

      {fieldArray.fields.length === 0 && (
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            textDecoration: 'underline',
          }}
        >
          No Addresses
        </Typography>
      )}

      <Button
        variant="contained"
        size="small"
        fullWidth
        onClick={() => {
          fieldArray.append({
            priority: fieldArray.fields.length + 1,
            name: '',
            type: '',
            phone: '',
            extension: '',
          });
        }}
      >
        {fieldArray.fields.length > 0 ? 'Add Another Address' : 'Add Address'}
      </Button>
    </Stack>
  );
}

export default AddressFieldArray;
